import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import sw from './locales/sw.json';
import pt from './locales/pt.json';
import lg from './locales/lg.json';
import rw from './locales/rw.json';
import am from './locales/am.json';
import ha from './locales/ha.json';
import ny from './locales/ny.json';
import ku from './locales/ku.json';
import ar from './locales/ar.json';
import es from './locales/es.json';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  sw: { translation: sw },
  pt: { translation: pt },
  lg: { translation: lg },
  rw: { translation: rw },
  am: { translation: am },
  ha: { translation: ha },
  ny: { translation: ny },
  ku: { translation: ku },
  ar: { translation: ar },
  es: { translation: es },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'spi-language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
